import { useState } from 'react';
import { Box, Drawer } from '@material-ui/core';
import { useComposeEmail } from 'providersV2/compose-email/context';
import { EmailForm } from 'providersV2/compose-email/components';
import { htmlTags } from '@setvi/shared/utils';
import { EmailHeader } from '../header/content';
import { CancelConfirmation } from '../cancel-confirmation';
import { mobileDriverStyle } from '../..';

interface MobileEditorProps {
  handleClose: () => void;
}

export const MobileEditor = ({ handleClose }: MobileEditorProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {
    values,
    editorValues: { toggleDrawer, onSubmit, closeComposeEmail, ...restProps }
  } = useComposeEmail();

  const closeEmailEditor = () => {
    if (
      values.sendTo.length === 0 &&
      values.subject.trim().length === 0 &&
      values.body.replace(htmlTags, '').trim().length === 0
    ) {
      handleClose();
      closeComposeEmail();
      return;
    }
    setDrawerOpen(true);
  };

  return (
    <>
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        overflow="hidden">
        <EmailHeader onClose={closeEmailEditor} />
        <Box flex={1} display="flex">
          <EmailForm
            onSubmit={() => {
              handleClose();
              onSubmit();
            }}
            blurBehavior="add"
            disableContactSuggestion
            {...restProps}
          />
        </Box>
      </Box>
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          style: {
            ...mobileDriverStyle,
            padding: 20,
            height: 270
          }
        }}>
        <CancelConfirmation
          title="Discard your email"
          description="Are you sure you want to discard your entered data in this email?"
          additionalContent="The action CANNOT be reverted back"
          confirmText="Discard & Close"
          cancelText="Keep it"
          onConfirm={() => {
            handleClose();
            closeComposeEmail();
          }}
          onCancel={() => setDrawerOpen(false)}
        />
      </Drawer>
    </>
  );
};
